<template lang="pug">
.row

  .col-sm-6
    .form-group(:class="{'has-error': errors.has('title') || existing_title}")
      input.form-control(name="title",
                         type="text",
                         v-model="title",
                         v-validate="'required'",
                         placeholder="Novo motivo de perda")
      transition-group(name='fade')
        .help-block(v-show="errors.has('title')", key="title") Favor preencher o campo acima
        .help-block(v-show="existing_title", key="existing_title") O motivo de perda já existe

  .col-sm-3
    button.btn.btn-primary(@click="submit")
      span.icon-more +
      | Adicionar categoria

  .clear
  br
</template>

<script>
  const helpers = require('../../helpers.coffee')

  const view_model = {
    data() {
      return {
        title: '',
        existing_title: false
      }
    },

    methods: {
      submit() {
        this.$validator.validateAll({title: this.title}).then(success => {
          if (success) {
            if (this.search(this.title, this.$store.getters.lostReasonsList)){
              this.existing_title = true
            }else{
              this.createLostReason()
            }
          }
        })
      },

      search(titleKey, myArray){
        for (var i=0; i < myArray.length; i++) {
          if (myArray[i].title === titleKey) {
            console.log(myArray[i].title);
            return true;
          }
        }
      },

      createLostReason() {
        this.$store.dispatch('createLostReason', { title: this.title })
      }
    },
    watch: {
      title: function(newTitle, oldTitle) {
        if (newTitle === "") {
          this.existing_title = false
        }
      }
    }
  }

  exports.default = helpers.vue_include(view_model, helpers.form)
</script>

<style lang="sass" scoped>

  @import "../../assets/stylesheets/_variables.sass"

  input.form-control
    height: 38px

  .table-col
    padding-left: 20px
    padding-right: 20px


</style>



// WEBPACK FOOTER //
// new.vue?b82ce41a